var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorizontalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7415 11.5951C17.2018 11.5951 17.5749 11.222 17.5749 10.7617C17.5749 10.3015 17.2018 9.92839 16.7415 9.92839C16.2813 9.92839 15.9082 10.3015 15.9082 10.7617C15.9082 11.222 16.2813 11.5951 16.7415 11.5951Z",
    stroke: "#59758A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9085 11.5951C11.3688 11.5951 11.7419 11.222 11.7419 10.7617C11.7419 10.3015 11.3688 9.92839 10.9085 9.92839C10.4483 9.92839 10.0752 10.3015 10.0752 10.7617C10.0752 11.222 10.4483 11.5951 10.9085 11.5951Z",
    stroke: "#59758A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07454 11.5951C5.53478 11.5951 5.90788 11.222 5.90788 10.7617C5.90788 10.3015 5.53478 9.92839 5.07454 9.92839C4.61431 9.92839 4.24121 10.3015 4.24121 10.7617C4.24121 11.222 4.61431 11.5951 5.07454 11.5951Z",
    stroke: "#59758A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalIcon);
export default __webpack_public_path__ + "static/media/horizontal-icon.96bc00a9e1f61005deb105f40af6d05f.svg";
export { ForwardRef as ReactComponent };